import React, { useState, useEffect } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import ReactMarkdown from 'react-markdown'
import { useGetTeacherNewQuestionQuery, useCallOpenApiQuery } from '../../slices/teachers/teacherQuestionsApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const TeacherAiAnswer = () => {
      
    const navigate = useNavigate();

    const { id } = useParams();

    const { teacherInfo } = useSelector((state) => state.authTeacher);

    const { data, isLoading, error } = useCallOpenApiQuery(id);

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
    }, [navigate, teacherInfo])

  return (
    <div>
        <TeacherNavbar />
            <div className="main-content" id="panel">
            <TeacherHeader /><br /><br /><br />       
                <div className="container-fluid mt--6">
                    {isLoading ? ( 
                        <Loader />
                    ) : error ? (
                        <Message variant='danger'>
                            {error?.data?.message || error.error}
                        </Message>
                    ) : (
                        <div className="row">
                            <div className="col-xl-7 ">                               
                                <div className="card ">
                                    <div className="card-body "> <br />
                                        <img src='https://cdn-icons-png.flaticon.com/512/14313/14313824.png' 
                                            alt='logo' 
                                            className='aiHelper2' 
                                        />
                                        <span className='tittleColor aiHelper'>Answer From AI Assistant</span><br />
                                        {isLoading ? (
                                            <Loader />
                                        ) : (
                                            <>
                                                <p className='AItext'>
                                                    <ReactMarkdown>{data?.aiAnswer}</ReactMarkdown>
                                                </p> <br /><br />
                                            </>
                                        )}                                                             
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-5">                               
                                <div className=" mycard">
                                    <h3 className="tittleColor videoTitle">
                                        <span className='tittleColor4' style={{textTransform: 'capitalize'}}>
                                            {data?.subjectname}    
                                        </span>
                                    </h3>    
                                    <div className="card-body ">                                
                                        <h5 className="h4 card-title mb-0 mycard">
                                        <span className='tittleColor aiTittle'>{data?.tittle}</span>
                                        <p className="text-muted ">{data?.description}</p>
                                        </h5>    
                                        <video controls className="card-img-top">      
                                        <source 
                                            src={`https://bucketeer-f3a53e81-2e13-49e9-82ca-c504e025aced.s3.amazonaws.com/public/questions/${data?.mediaId}`}
                                            type="video/mp4"
                                        />
                                    </video> <br />  <br />             
                                        <LinkContainer to={`/teacheranswerdetails/${id}`} className='btn btn-default '>
                                          <Button variant="primary  bg-gradient-info"> Answer Question</Button>
                                      </LinkContainer> <br /><br />                                                                                                                                                   
                                    </div>
                                </div>
                            </div>                    
                        </div>
                    )}
                </div>        
            </div>      
    </div>
  )
}

export default TeacherAiAnswer
